import { useState } from "react";
import {
  Typography,
  Box,
  Link,
  Checkbox
} from "@material-ui/core";
import { Quote } from "../../../api/Quote/Quote";
import QuoteCartPayment from "./QuoteCartPayment";
import { Link as RouterLink } from "react-router-dom";

interface Props {
  quote: Quote;
  onPay: Function;
}

const QuoteCartPayActions = ({
  quote,
  onPay
}: Props) => {
  const [stateTerm, setStateTerm] = useState(false);

  const handleChangeTerm = (e: React.ChangeEvent<HTMLInputElement>) => {
    setStateTerm(e.target.checked);
  }

  return (
    <div>
      <Typography variant="h3" paragraph>
        Next Steps
      </Typography>

      <Box alignItems="center" textAlign="center">
        <Typography variant="body2">
          You can pay a fully refundable €{quote.depositRequirement} deposit to book your installation date or apply for finance via Humm by Flexifi
        </Typography>

        <Typography variant="body2" paragraph>
          <Checkbox
            checked={stateTerm}
            onChange={handleChangeTerm}
            color="secondary"
            inputProps={{ 'aria-label': 'secondary checkbox' }}
          />
          I have read and agree to the&nbsp;
          <Link component={RouterLink} to="/payment">
            terms and conditions
          </Link>
        </Typography>

        <QuoteCartPayment
          quote={quote}
          onPay={onPay}
          stateTerm={stateTerm}
        />


      </Box>
    </div>
  );
};

export default QuoteCartPayActions;
